import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>
            <div className="about-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            {/* About Image Box Start */}
                            <div className="about-image-box">
                                {/* About Image Start */}
                                <div className="about-image">
                                    <figure className="image-anime reveal" style={{ transform: 'translate(0px, 0px)', opacity: 1, visibility: 'inherit' }}>
                                        <img src="assets/img/About us_1.png" alt style={{ transform: 'translate(0px, 0px)' }} />
                                    </figure>
                                    {/* Contact Us Circle Start */}
                                    <div className="contact-us-circle">
                                        <a href="contact.html"><img src="assets/images/contact-us-circle.svg" alt /></a>
                                    </div>
                                    {/* Contact Us Circle End */}
                                </div>
                                {/* About Image End */}
                                {/* About Image Item Box Start */}
                                <div className="about-image-item-box">
                                    {/* About Image Item Start */}
                                    <div className="about-image-item">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-about-image-item.svg" alt />
                                        </div>
                                        <div className="about-image-item-content">
                                            <h2><span className="counter">100</span>%</h2>
                                            <h3> Natural</h3>
                                        </div>
                                    </div>
                                    {/* About Image Item End */}
                                    {/* About Image Start */}
                                    <div className="about-image">
                                        <figure className="image-anime reveal" style={{ transform: 'translate(0px, 0px)', opacity: 1, visibility: 'inherit' }}>
                                            <img src="assets/img/About us_2.webp" alt style={{ transform: 'translate(0px, 0px)' }} />
                                        </figure>
                                    </div>
                                    {/* About Image End */}
                                </div>
                                {/* About Image Item Box End */}
                            </div>
                            {/* About Image Box End */}
                        </div>
                        <div className="col-lg-6">
                            {/* About us Content Start */}
                            <div className="about-us-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>About us</h3>
                                    <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                        Mahua Shakti Blend – Ancient Nutrition, Modern Strength
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>CND Mahua Shakti Blend Is A Unique Combination Of Mahua & 11+ Natural Ingredients Including Mahua, Dry Fruits, Seeds And Sleeted Nuts, Carefully, Roasted And Blended To Bring You The Goodness Of Nature In Every Spoon. A Perfect Choice For Your Daily Nutrition.</p>
                                </div>
                                {/* Section Title End */}
                                {/* About Us Body Start */}
                                <div className="about-us-body wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    {/* About Body Item Start */}
                                    <div className="about-body-item active">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-about-body-1.svg" alt />
                                        </div>
                                        <div className="about-body-content">
                                            <h3>Mahua Shakti Blend – Nature’s Power in Every Spoon</h3>
                                            <p>Premium, memorable, and easy for customers to understand.</p>
                                        </div>
                                    </div>
                                    {/* About Body Item End */}
                                    {/* About Body Item Start */}
                                    <div className="about-body-item">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-about-body-2.svg" alt />
                                        </div>
                                        <div className="about-body-content">
                                            <h3>Ancient Nutrition, Modern Wellness</h3>
                                            <p >Gives a premium traditional health positioning.</p>
                                        </div>
                                    </div>
                                    {/* About Body Item End */}
                                </div>
                                {/* About Us Body End */}
                            </div>
                            {/* About us Content End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeAbout